import React from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import { IconDownload, IconFile } from '@tabler/icons-react';

interface ChatFileAttachmentProps {
  fileUrl: string;
  fileName?: string;
}

const ChatFileAttachment: React.FC<ChatFileAttachmentProps> = ({
  fileUrl,
  fileName,
}) => {
  // Extract filename from URL if not provided
  const displayName = fileName || fileUrl.split('/').pop() || 'File';
  // Get file extension
  const extension = displayName.split('.').pop()?.toUpperCase() || 'FILE';

  const handleOpen = () => {
    window.open(fileUrl, '_blank');
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        maxWidth: '320px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
          elevation: 3,
          backgroundColor: 'action.hover',
        },
      }}
      onClick={handleOpen}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 1,
          backgroundColor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <IconFile size={24} color="white" />
      </Box>

      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" color="textSecondary" fontWeight={600}>
          {extension}
        </Typography>
        <Typography
          variant="subtitle2"
          noWrap
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {displayName}
        </Typography>
      </Box>

      <IconButton
        size="small"
        color="primary"
        onClick={e => {
          e.stopPropagation();
          handleOpen();
        }}
      >
        <IconDownload size={20} />
      </IconButton>
    </Paper>
  );
};

export default ChatFileAttachment;
